import React from 'react';
import MsgNetLoading from '../components/MsgNetLoading';
import EventoList from '../components/EventoList';
import CONFIG from '../config';

class EventoListScreenClass extends React.Component {
  constructor(props) {
    super(props);
    this.state = { eventos: [], isLoading: true };
  }

  componentDidMount() {
    this.fetchEventos();
    this._unmounted = false;
    this._connectWS();
  }

  _connectWS() {
    if (this._unmounted) return;
    const ws = new WebSocket(`${CONFIG.WS_URL}/ws/0`);
    this._ws = ws;
    ws.onmessage = (e) => {
      try {
        const msg = JSON.parse(e.data);
        if (msg.tipo === 'eventos_update') this.fetchEventos();
      } catch (_) {}
    };
    ws.onclose = () => {
      this._ws = null;
      if (!this._unmounted) setTimeout(() => this._connectWS(), 2000);
    };
    ws.onerror = () => ws.close();
  }

  componentWillUnmount() {
    this._unmounted = true;
    if (this._ws) { this._ws.close(); this._ws = null; }
  }

  fetchEventos() {
    fetch(`${CONFIG.API_URL}/api/1.0/live/eventos/`)
      .then(r => r.json())
      .then(eventos => this.setState({ eventos, isLoading: false }))
      .catch(err => {
        console.error('live-eventos error:', err);
        this.setState({ isLoading: false });
      });
  }

  render() {
    return this.state.isLoading
      ? <MsgNetLoading />
      : <EventoList eventos={this.state.eventos} />;
  }
}

function EventoListScreen() {
  return <EventoListScreenClass />;
}

export default EventoListScreen;
